import { ReactNode } from 'react';
import { Loader } from '..';
import { CardContainer } from '../../card';
import { Heading } from '../../heading';
import { Modal } from '../../utility';

interface LoadingModal {
  isLoading: boolean;
  label?: string;
  children?: ReactNode;
}

function LoadingModal({ label = 'Loading...', children }: LoadingModal) {
  return (
    <Modal className='h-80 w-80'>
      <CardContainer
        stripPadding={true}
        bodyClassName='w-full h-full flex flex-col items-center justify-center'
      >
        <div className='flex h-full w-full flex-col items-center justify-center space-y-8'>
          <Loader color='GREEN' size='XL' />
          <Heading label={label} size='H3' />
        </div>

        {children ? <div>{children}</div> : null}
      </CardContainer>
    </Modal>
  );
}

export default LoadingModal;
